import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';
import moment from 'moment';


@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService, private datePipe: DatePipe) {}

  transform(value: string | Date | number, pattern: string = 'mediumDate', timezone:string=undefined,extraPattern:string=undefined): string {
    const patternWithExtra = extraPattern ? `${pattern} ${extraPattern}` : pattern;
    if(!timezone) return this.datePipe.transform(value, patternWithExtra, undefined, this.translateService.currentLang);
    const date = moment(value).valueOf();
    const tz = TimezoneService.ianaToGMT(timezone,date);
    return this.datePipe.transform(date, patternWithExtra, tz, this.translateService.currentLang);
  }
}
